export default "__VITE_ASSET__556f3a3c__"